<template>
  <div class="two-factor-login">

    <div>
      <div class="header" v-if="backEnabled">
        <img :src="require('@/assets/icons/ic-close.svg')" v-on:click="closeAction">
      </div>
      <img class='image' :src="require('@/assets/hero-login.svg')">

      <div class="content">
        <img :src="require('@/assets/2fa-login/shield.svg')" class="shield">
        <span class="mini-title r-typo-headline-label">הזדהות ב-2 שלבים</span>
        <slot name="text"/>
        <riseup-button :action="buttonAction" :title="buttonTitle"></riseup-button>
      </div>

    </div>
    <login-support-footer class="footer-2fa"/>
  </div>
</template>

<script>

import Segment from '@/Segment';
import BaseUI from 'base-ui';
import router from '../../../../router';

export default {
  name: 'TwoFactorScreen',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    LoginSupportFooter: BaseUI.LoginSupportFooter,
  },
  props: {
    buttonTitle: {
      type: String,
      required: true,
    },
    buttonAction: {
      type: Function,
      required: true,
    },
    backEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentMember: {},
    };
  },
  methods: {
    async closeAction() {
      Segment.trackUserInteraction('TwoFactorScreenClose');
      await router.push({ path: '/home' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../../../scss/mixins';

.two-factor-login {

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  height: 100%;

  .header {
    display: flex;
    justify-content: flex-end;
    padding: 20px;
  }

  .image {
    width: 100%;
  }

  .content {
    padding: 50px 30px 0 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .shield {
      width: 15%;
    }

    .mini-title {
      padding-top: 40px;
    }

    .riseup-button {
      height: 75px;
      font-size: 20px;
      align-self: flex-end;
      margin-top: 75px;
      width: 100%;
    }
  }

  .footer-2fa {
    width: 100%;
    bottom: 0;
    padding: 0 30px 30px 30px;
  }
}

</style>
